<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="17.308" height="21.633" viewBox="0 0 17.308 21.633">
		<path d="M9,7.311v20.51a.528.528,0,0,0,.791.487L26.049,18.053a.581.581,0,0,0,0-.967L9.791,6.831A.523.523,0,0,0,9,7.311Z" transform="translate(-9 -6.751)" fill="currentColor"/>
	</svg>
</template>
